import { PerformanceRiskAnalysis } from './analysis/performance-risk-analysis.model';

export class CurrentBenchmark {
  public id: number;
  public name: string;
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;
  public investment_date: Date;
  public last_update: Date;

  public performance_risk_analysis: PerformanceRiskAnalysis;

  public performanceRiskAnalysis: PerformanceRiskAnalysis;

  constructor(id: number) {
      this.id = id;
  }

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.name            = data.name ? data.name : undefined;
    this.creation_date   = data.creation_date ? new Date(data.creation_date) : undefined;
    this.inception_date  = data.inception_date ? new Date(data.inception_date) : undefined;
    this.last_date       = data.last_date ? new Date(data.last_date) : undefined;
    this.investment_date = data.investment_date ? new Date(data.investment_date) : undefined;
    this.last_update     = data.last_update ? new Date(data.last_update) : undefined;

    this.performance_risk_analysis = data.performance_risk_analysis ? data.performance_risk_analysis : undefined;
    this.performanceRiskAnalysis = new PerformanceRiskAnalysis();
    this.performanceRiskAnalysis.initFromData(this.performance_risk_analysis)
  }
}
